import { tabletMax } from '@propertypal/shared/src/constants/mediaQueries';
import styled, { css } from 'styled-components';
import { Heading } from '../typography';

export const Container = styled.div`
  padding: 40px 0 100px 0;

  @media (${tabletMax}) {
    padding-bottom: 60px;
  }
`;

export const Wrapper = styled.div`
  padding: 0 10px;
  max-width: 820px;
  margin: 0 auto;

  @media (${tabletMax}) {
    ${Heading} {
      font-size: 34px;
    }
  }
`;

export const TableContainer = styled.div<{ hasScrollBtns?: boolean }>`
  width: 100%;
  max-width: 820px;
  margin-top: ${({ hasScrollBtns }) => (hasScrollBtns ? 0 : 35)}px;
  overflow-x: auto;
  position: relative;
`;

export const Table = styled.table`
  width: 100%;
  text-indent: 0;
  border-color: inherit;
  border-collapse: collapse;
  border: 1px solid ${({ theme }) => theme.keyline};
`;

export const TableHeader = styled.thead`
  border: 1px solid ${({ theme }) => theme.keyline};
`;

export const TableHead = styled.th<{ leftAlign?: boolean; highlight?: boolean }>`
  border: 1px solid ${({ theme }) => theme.keyline};
  border-bottom-color: ${({ theme }) => theme.greyDivider};
  border-bottom-width: 2px;
  width: calc(100% / 3);
  min-width: 240px;
  height: 90px;
  padding: 0 20px;
  text-align: ${({ leftAlign }) => (leftAlign ? 'left' : 'center')};
  ${({ highlight, theme }) =>
    highlight
      ? css`
          border-left-width: 2px;
          border-right-width: 2px;
          background-color: ${theme.primary};
          color: ${theme.white};
          border-color: ${theme.primary};
        `
      : ''}
`;

export const TableRow = styled.tr`
  border: 1px solid ${({ theme }) => theme.keyline};

  &:nth-child(even) {
    background-color: ${({ theme }) => theme.backgroundLighter};
  }
  &:nth-child(odd) {
    background-color: ${({ theme }) => theme.white};
  }
`;

export const TableCell = styled.td<{
  leftAlign?: boolean;
  bold?: boolean;
  highlight?: boolean;
  lastRow?: boolean;
  isBoost?: boolean;
  lastCell?: boolean;
}>`
  border: 1px solid ${({ theme }) => theme.keyline};
  height: 90px;
  padding: 0 20px;
  position: relative;
  text-align: ${({ leftAlign }) => (leftAlign ? 'left' : 'center')};
  ${({ bold }) =>
    bold
      ? css`
          font-weight: bold;
        `
      : ''}

  ${({ highlight, theme }) =>
    highlight
      ? css`
          border-right: 2px solid ${theme.primary};
          border-left: 2px solid ${theme.primary};
        `
      : ''}
  
  ${({ isBoost, bold, theme }) =>
    isBoost
      ? css`
          background-color: ${bold ? theme.primary : 'rgba(238, 73, 0, 0.05)'};
          border-top: 2px solid ${theme.primary};
          border-bottom: 2px solid ${theme.primary};
        `
      : ''}
  
  ${({ isBoost, lastCell, theme }) =>
    isBoost && lastCell
      ? css`
          border-right: 2px solid ${theme.primary};
        `
      : ''}
 
 ${({ isBoost, bold, theme }) =>
    isBoost && bold
      ? css`
          color: ${theme.white};
        `
      : ''}
      
  ${({ highlight, lastRow, theme }) =>
    highlight && lastRow
      ? css`
          border-bottom: 2px solid ${theme.primary};
        `
      : ''}
`;

export const TableBody = styled.tbody`
  font-size: 14px;

  ${TableRow}:last-child {
    font-weight: bold;
    ${TableCell} {
      border-top-color: ${({ theme }) => theme.greyDivider};
      border-top-width: 2px;
    }
  }
`;

export const CellContainer = styled.div`
  position: relative;
  z-index: 1;
`;

export const CellOverlay = styled.div`
  position: absolute;
  background-color: rgba(238, 73, 0, 0.05);
  inset: 0px;
`;

export const TableFooterCells = styled.span<{ uppercase?: boolean }>`
  display: block;
  font-weight: bold;
  font-size: 16px;

  &:last-child {
    margin-top: 5px;
  }

  ${({ uppercase }) =>
    uppercase
      ? css`
          text-transform: uppercase;
        `
      : ''}

  b {
    color: ${({ theme }) => theme.primary};
  }
`;

export const ScrollContainer = styled.div`
  margin: 20px 0 5px 0;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 10px;
`;

export const ScrollButton = styled.button`
  color: ${({ theme }) => theme.textDark};
  background-color: ${({ theme }) => theme.backgroundLightest};
  height: 50px;
  width: 50px;
  text-align: center;
  border-radius: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: background-color 150ms linear;

  &:hover {
    background-color: ${({ theme }) => theme.backgroundLight};
  }
`;
